/**
 * Navigation Service
 * Allows navigation from outside React components (e.g., contexts, services)
 */
import { createNavigationContainerRef, CommonActions } from '@react-navigation/native';
import { MainStackParamList } from '../navigation/MainNavigator';

export const navigationRef = createNavigationContainerRef<MainStackParamList>();

export function navigate(name: keyof MainStackParamList, params?: any) {
  if (navigationRef.isReady()) {
    navigationRef.navigate(name as any, params);
  }
}

export function goBack() {
  if (navigationRef.isReady() && navigationRef.canGoBack()) {
    navigationRef.goBack();
  }
}

export function reset(name: keyof MainStackParamList) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name }],
      })
    );
  }
}

/**
 * Navigate to home/dashboard based on user role
 * - org_employee -> DashboardStack
 * - strategy_team/superuser/executive -> StrategyStack (executive is VIEW ONLY)
 */
export function navigateToHome(userType: string | undefined) {
  if (!navigationRef.isReady()) return;

  // executive uses StrategyStack (same as strategy_team) but with VIEW-ONLY permissions
  if (userType === 'strategy_team' || userType === 'superuser' || userType === 'executive') {
    navigationRef.navigate('StrategyStack' as any);
  } else {
    navigationRef.navigate('DashboardStack' as any);
  }
}

/**
 * Navigate to Goals based on user role
 * - org_employee -> GoalsStack
 * - strategy_team/superuser/executive -> StrategyStack with Goals screen
 */
export function navigateToGoals(userType: string | undefined) {
  if (!navigationRef.isReady()) return;

  // executive uses StrategyStack (same as strategy_team)
  if (userType === 'strategy_team' || userType === 'superuser' || userType === 'executive') {
    navigationRef.navigate('StrategyStack' as any, {
      screen: 'Goals',
    });
  } else {
    navigationRef.navigate('GoalsStack' as any, {
      screen: 'Goals',
    });
  }
}

/**
 * Navigate to GoalDetail based on user role
 * - org_employee -> GoalsStack
 * - strategy_team/superuser/executive -> StrategyStack
 */
export function navigateToGoalDetail(userType: string | undefined, goalId: number) {
  if (!navigationRef.isReady()) return;

  // executive uses StrategyStack (same as strategy_team)
  if (userType === 'strategy_team' || userType === 'superuser' || userType === 'executive') {
    navigationRef.navigate('StrategyStack' as any, {
      screen: 'GoalDetail',
      params: { id: goalId },
    });
  } else {
    navigationRef.navigate('GoalsStack' as any, {
      screen: 'GoalDetail',
      params: { id: goalId },
    });
  }
}
